import { Button, Card, CardActions, CardContent, Container, Divider, Grid, Stack, Typography } from "@mui/material";
import { variables } from "../../styles/abstract/variables";
import { KeyboardArrowLeft, KeyboardArrowRight, Save } from "@mui/icons-material";
import $data from "../../services/$data";
import { useContext, useState } from "react";
import { AppContext } from "../../AppContext";
import { Redirect } from "react-router-dom";

function CarbonAssessmentResult({ prevStep, model, calculateTotal, isEdit, id }) {
  const {selected} = useContext(AppContext);
  const [redirect, setRedirect] = useState(false);

  const isEnabled = () => {
    const { residues, pesticides, fertilizers, animals, soil, fuel, irrigation } = model;
    return (
      residues.totalEmission ||
      pesticides.totalEmission ||
      fertilizers.totalEmission ||
      animals.totalEmission ||
      soil.totalEmission ||
      fuel.totalEmission ||
      irrigation.totalEmission
    );
  }

  const renderContent = () => {
    const { residues, pesticides, fertilizers, animals, soil, fuel, irrigation } = model;

    if (!isEnabled()) {
      return (
        <Grid item xs={12} textAlign={"center"}>
          <Typography>
            You need to complete input for <strong>at least one category</strong> in order to <strong>save</strong> this assessment!
          </Typography>
          <Typography color="error" fontWeight="bold">
            Note: Keep in mind that it is advised to complete every category (if applicable)
          </Typography>

        </Grid>
      );
    }

    return (
      <Grid item xs={12} sx={{ mt: '40px', mb: '40px' }}>
        <Stack justifyContent="center" alignItems="center" sx={{ margin: '0 auto', border: `20px solid ${variables.primary}`, borderRadius: '100%', width: '250px', height: '250px' }}>
          <Typography fontWeight="bold" variant="h4" textAlign="center">{calculateTotal(model)}</Typography>
        </Stack>
      </Grid>
    );
  }

  const onSubmit = async () => {
    try {
      if(isEdit) {
        const report = await $data.updateCCRecord(model, id);
        setRedirect(true);
  
      } else {
        const report = await $data.postCCRecords(model);
        setRedirect(true);
  
      }
    } catch (error) {

    }
  }

  if(redirect) {
    return <Redirect to={`/dashboard/project/${selected}/carbon-emissions/`} />
  }

  return (
    <Container>
      <Grid container spacing={2}>


        <Grid item xs={12}>
          <Card elevation={5} style={{ borderRadius: 0, background: 'transparent' }}>
            <CardContent className="co-background" sx={{ padding: '40px' }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h4" fontWeight="bold">Total emissions</Typography>
                </Grid>



                <Grid item xs={12}>
                  <Divider color="primary" light style={{ background: variables.primary, height: '3px' }} />
                </Grid>

                {renderContent()}


              </Grid>
            </CardContent>
            <CardActions style={{ padding: '0 16px 16px 16px', justifyContent: 'flex-end' }} className="co-background">
              <Button onClick={prevStep} variant="contained" endIcon={<KeyboardArrowLeft />}>Previous</Button>
              <Button disabled={!isEnabled()} onClick={onSubmit} variant="contained" color="warning" endIcon={<Save />}>Save</Button>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}

export default CarbonAssessmentResult;